import {
  SET_CURRENCY_RATE_SUCCESS,
  CLEAR_SET_CURRENCY_RATE_SUCCESS,
  SET_SYSTEM_CURRENCY_SUCCESS,
  CLEAR_SET_SYSTEM_CURRENCY_SUCCESS,
  GET_CURRENCY_RATES_SUCCESS,
  GET_SYSTEM_CURRENCY_SUCCESS,
  DEACTIVATE_CURRENCY_RATE_SUCCESS,
  DELETE_CURRENCY_RATE_SUCCESS,
  LOGOUT,
} from "../types";

const initialState = {
  currencyRates: [],
  systemCurrency: null,
  setCurrencyRateSuccess: false,
  setSystemCurrencySuccess: false,
};

const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENCY_RATE_SUCCESS:
      return {
        ...state,
        setCurrencyRateSuccess: true,
        currencyRates: state.currencyRates.map((rate) =>
          rate._id === action.payload.currencyRate._id
            ? action.payload.currencyRate
            : rate
        ),
      };

    case CLEAR_SET_CURRENCY_RATE_SUCCESS:
      return {
        ...state,
        setCurrencyRateSuccess: false,
      };

    case SET_SYSTEM_CURRENCY_SUCCESS:
      return {
        ...state,
        setSystemCurrencySuccess: true,
        systemCurrency: action.payload.currency,
      };

    case CLEAR_SET_SYSTEM_CURRENCY_SUCCESS:
      return {
        ...state,
        setSystemCurrencySuccess: false,
      };

    case GET_CURRENCY_RATES_SUCCESS:
      return {
        ...state,
        currencyRates: action.payload.rates || [],
      };

    case GET_SYSTEM_CURRENCY_SUCCESS:
      return {
        ...state,
        systemCurrency: action.payload.systemCurrency,
      };

    case DEACTIVATE_CURRENCY_RATE_SUCCESS:
      return {
        ...state,
        currencyRates: state.currencyRates.map((rate) =>
          rate._id === action.payload._id ? { ...rate, isActive: false } : rate
        ),
      };

    case DELETE_CURRENCY_RATE_SUCCESS:
      return {
        ...state,
        currencyRates: state.currencyRates.filter(
          (rate) => rate._id !== action.payload._id
        ),
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default currencyReducer;
